import {DestroyRef, Directive, type OnInit, inject, input, output} from '@angular/core'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {Subject, throttleTime} from 'rxjs'

@Directive({
  selector: '[appDebounceDirective]',
  host: {
    '(click)': 'clickEvent($event)',
  },
})
export class DebounceDirective implements OnInit {
  readonly #destroyRef = inject(DestroyRef)

  readonly debounceTime = input(200)
  readonly debounceClick = output<unknown>()

  readonly #clicks = new Subject()

  ngOnInit() {
    this.#clicks
      .pipe(throttleTime(this.debounceTime()), takeUntilDestroyed(this.#destroyRef))
      .subscribe(e => this.debounceClick.emit(e))
  }

  clickEvent(event: Event) {
    const target = event.target as HTMLButtonElement
    if (target?.disabled) {
      return
    }

    event.preventDefault()
    event.stopPropagation()
    this.#clicks.next(event)
  }
}
